import Grid from "@mui/material/Grid2";
import UsersDonutChart from "./UsersDonutChart";
import { DonutSegment } from "./usersApiMapping";

interface UsersFunnelDonutsProps {
  leadToQualifiedSegments: DonutSegment[];
  qualifiedByZipSegments: DonutSegment[];
  leadToMatchedSegments: DonutSegment[];
  leadToPaidSegments: DonutSegment[];
  leads: number;
  qualified: number;
  matched: number;
  paid: number;
}

export default function UsersFunnelDonuts({
  leadToQualifiedSegments,
  qualifiedByZipSegments,
  leadToMatchedSegments,
  leadToPaidSegments,
  leads,
  qualified,
  matched,
  paid,
}: UsersFunnelDonutsProps) {
  return (
    <Grid container spacing={2.5}>
      <Grid size={{ xs: 12, md: 6 }}>
        <UsersDonutChart
          title="Lead to qualified"
          segments={leadToQualifiedSegments}
          centerValue={leads}
          centerLabel="Leads"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <UsersDonutChart
          title="Qualified by zip code"
          segments={qualifiedByZipSegments}
          centerValue={qualified}
          centerLabel="Qualified"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <UsersDonutChart
          title="Lead to matched"
          segments={leadToMatchedSegments}
          centerValue={matched}
          centerLabel="Leads"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <UsersDonutChart
          title="Lead to paid"
          segments={leadToPaidSegments}
          centerValue={paid}
          centerLabel="Leads"
        />
      </Grid>
    </Grid>
  );
}
